// Copyright (c) 2016 Deere & Company

import actions from '../../../action-list';
import {findMatchingKey} from '../../../shared/services/claim-shared-helper';

export const updateGoodsInstallationVat = (key, options) => ({
    goodsInstallationVat: findMatchingKey(key, options),
    type: actions.UPDATE_CLAIM_MCC_FOLLOWUP_GOODS_INSTALLATION_VAT
});



// WEBPACK FOOTER //
// ./src/claim/marketing/mass-channel-customer-followup/action-creators/update-goods-installation-vat.js